export default {
  "A": "Agriculture, forestry, and fishing",
  "B": "Mining and quarrying",
  "C": "Manufacturing",
  "D": "Electricity, gas, steam, and air conditioning supply",
  "E": "Water supply: sewerage, waste management and remediation activities",
  "F": "Construction",
  "G": "Wholesale and retail trade: repair of motor vehicles and motorcycles",
  "H": "Transportation and storage",
  "I": "Accommodation and food service activities",
  "J": "Information and communication",
  "K": "Financial and insurance activities",
  "L": "Real estate activities",
  "M": "Specialized, scientific, and technical activities",
  "N": "Administrative and support service activities",
  "O": "Public administration",
  "P": "Education",
  "Q": "Human health and social work activities",
  "R": "Arts, entertainment, and recreation",
  "S": "Other service activities",
  "T": "Activities of households as employers",
  "U": "Extra-territorial activities"
}